import React from 'react';
import { Modal, Button, Box, Typography } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const SessionExpiredModal = ({ isOpen, onConfirm }) => {
    return (
        <Modal
            open={isOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            disableBackdropClick
            disableEscapeKeyDown
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Session Expired
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Your session has expired. Please log in again.
                </Typography>
                <Button
                    variant="contained"
                    onClick={onConfirm}
                    sx={{ mt: 2 }}
                >
                    OK
                </Button>
            </Box>
        </Modal>
    );
};

export default SessionExpiredModal;